// import React from 'react'
import Tooltip from "@mui/material/Tooltip";

export default function SidebarTooltip(props) {
  return (
    <>
      {props.isSidebarCollapsed ? (
        // <Tooltip title={props.title}>
        //   <label>{props.title}</label>
        // </Tooltip>
        <label title={props.title}>{props.title}</label>
      ) : (
        <label>{props.title}</label>
      )}
    </>
  );
}
